import { useSetAtom } from "jotai";
import { type Ref, useImperativeHandle, useRef } from "react";

import { LocationDialog } from "./components/LocationDialog";
import { hideAtom, showAtom } from "./stores";
import type { CreatedLocation } from "./types";

export interface LocationModalHandle {
  open: (
    contactId?: number,
    originElement?: HTMLElement,
  ) => LocationModalHandle;
  hide: () => LocationModalHandle;
}

export type LocationModalProps = {
  onSubmit?: (location: CreatedLocation) => void;
  onCancel?: () => void;
  ref?: Ref<LocationModalHandle>;
};

function LocationModalContent({ onSubmit, onCancel, ref }: LocationModalProps) {
  const show = useSetAtom(showAtom);
  const hide = useSetAtom(hideAtom);
  const originRef = useRef<DOMRect | null>(null);

  const handle: LocationModalHandle = {
    open: (contactId, originElement) => {
      originRef.current = originElement?.getBoundingClientRect() ?? null;
      show(contactId ?? null);
      return handle;
    },
    hide: () => {
      hide();
      return handle;
    },
  };

  useImperativeHandle(ref, () => handle, []);

  return (
    <LocationDialog
      onSubmit={onSubmit}
      onCancel={onCancel}
      originRef={originRef}
    />
  );
}

export function LocationModal({ onSubmit, onCancel, ref }: LocationModalProps) {
  return (
    <LocationModalContent onSubmit={onSubmit} onCancel={onCancel} ref={ref} />
  );
}
